import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import SEO from "../components/SEO";
import ServiceCard from "../components/ServiceCard";
import TrustBar from "../components/TrustBar";
import FinalCTABanner from "../components/FinalCTABanner";
import CallButton from "../components/CallButton";
import { SERVICES } from "../data/services";
import { IMAGES, BUSINESS } from "../data/constants";

export default function Services() {
  return (
    <>
      <SEO
        title="Garage Door & Locksmith Services | GTA Garage Doors"
        description="From spring replacement to emergency break-in repair - GTA Garage Doors offers fast, professional service across the Greater Toronto Area."
        canonical="/services"
        ogImage={IMAGES.heroTechnician}
      />

      {/* Hero */}
      <section className="relative bg-[#1B2A4A] text-white" data-testid="services-hero">
        <img
          src={IMAGES.garageDoorHouse}
          alt="Modern residential garage door installation in a GTA home"
          className="absolute inset-0 w-full h-full object-cover opacity-25"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A] via-[#1B2A4A]/90 to-[#1B2A4A]/60" aria-hidden />
        <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24 lg:py-28">
          <nav className="text-xs text-white/60 font-bold uppercase tracking-widest font-display" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#FF6B00]" data-testid="breadcrumb-home">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-white">Services</span>
          </nav>
          <h1 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl leading-[1.05]">
            Every residential emergency. <span className="text-[#FF6B00]">One call.</span>
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-white/85 leading-relaxed">
            Garage doors, openers, springs, locks, break-in repair, and new
            installations — all handled by licensed GTA technicians, day or
            night.
          </p>
          <div className="mt-8">
            <CallButton size="lg" testId="services-hero-call-button" />
          </div>
        </div>
      </section>

      <TrustBar variant="dark" />

      <section className="section-pad bg-white">
        <div className="container-wide">
          <div className="eyebrow">All services</div>
          <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1B2A4A] max-w-3xl">
            Pick your emergency. We're dispatched.
          </h2>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {SERVICES.map((s) => (
              <ServiceCard key={s.slug} service={s} />
            ))}
          </div>

          <div className="mt-12 rounded-sm bg-[#1B2A4A] text-white p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <div className="eyebrow !text-white/60">Not sure which service you need?</div>
              <div className="mt-2 font-display font-black text-2xl md:text-3xl tracking-tight">
                Describe it in 30 seconds. We'll diagnose over the phone.
              </div>
            </div>
            <CallButton size="lg" testId="services-footer-call-button" />
          </div>
        </div>
      </section>

      <FinalCTABanner />
    </>
  );
}
